(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-page-findorder"]) return;
  try {
    
  const modal = document.getElementById('truck-comtainer-modal');
  const openModal =  document.getElementById('openModal');
  
  openModal.addEventListener('click', ()=>{
    modal.style.display="block"
  })


  

  } catch(e) { console.error(e); }
})();
})();
